import React from 'react';
import { Page, Text, View, Image } from '@react-pdf/renderer';

import hgsdLogo from '../../black-textHGSDlogo400px.png';
import ftBendLogo from '../../fbsd_logo_clr_rgb.png';

const MONTHS = [
  '',
  'DECEMBER',
  'JANUARY',
  'FEBRUARY',
  'MARCH',
  'APRIL',
  'MAY',
  'JUNE',
  'JULY',
  'AUGUST',
  'SEPTEMBER',
  'OCTOBER',
  'NOVEMBER',
  'DECEMBER',
  'JANUARY',
];

function getPrevMonth(month) {
  console.log(`month: ${month}`);
  return MONTHS[parseInt(month)];
}

function getResult(result) {
  switch (result) {
    default:
      return result;
  }
}

export default function AppendixJ({ styles, data, year, month, footer }) {
  return (
    <Page size='A4'>
      <View style={styles.pageTitle}>
        <Text style={styles.pageTitle}></Text>
      </View>
      <View style={styles.document}>
        <View style={[styles.row, styles.borderBottom]}>
          <Image
            src={window.config.client === 'FT-BEND' ? ftBendLogo : hgsdLogo}
            style={styles.logo}
          />
          <Text style={styles.logoLabel}>Appendix J</Text>
        </View>
        <View style={[styles.row, styles.borderBottom]}>
          <Text style={styles.logo} />
          <Text style={styles.logoLabel}>Take No Action Applications</Text>
        </View>
        <View style={styles.section}>
          <Text>
            {`The following applications were considered during the ${getPrevMonth(
              month
            )} Hearing, and no action is being taken on applications (if submitted).`}
          </Text>
        </View>
        <View style={styles.section}>
          <View style={[styles.row, styles.borderBottom]}>
            <Text style={styles.column}>APPLICANT</Text>
            <Text style={styles.column}>PERMIT</Text>
            <Text style={styles.column}>REASON</Text>
            <Text style={styles.column}>RECOMMENDATION</Text>
          </View>
          {data.length === 0 ? (
            <View style={styles.column}>
              <Text>NONE</Text>
            </View>
          ) : null}
          {data.map((permit) => (
            <View style={styles.row}>
              <Text style={styles.column}>{permit.PERMITTEE}</Text>
              <Text style={styles.column}>{permit.CASE_NUMBER}</Text>
              <Text style={styles.column}>{getResult(permit.RESULT)}</Text>
              <Text style={styles.column}>{permit.RECOMMENDATION}</Text>
            </View>
          ))}
        </View>
      </View>
      <View fixed style={styles.footer}>
        {/* <Text style={styles.data}>{footer}</Text> */}
        <Text
          style={styles.data}
          render={({ pageNumber, totalPages }) =>
            `${footer} (${pageNumber}/${totalPages})`
          }
        />
      </View>
    </Page>
  );
}
